export default {
    header: {
        resize: 'Size',
        createInfo:
            'After the design is created, a new canvas will be ready. View current poster content in the design records.',
        okText: 'Confirm',
        cancelText: 'Cancel',
        designNow: 'Create blank canvas',
        download: 'Download',
        PngDescribe: 'Lossless image quality with large file size. Supports a transparent background.',
        JpgDescribe: 'Small file size. Does not support a transparent background.',
        splitDownloadMode: 'Download split pages',
        wholeDownloadMode: 'Download full page ',
        pptFile: 'PPT file',
        pdfFile: 'PDF file',
        pptWithEditDesc:
            'If you download as an editable PPT file, some styles may not be restored. Editing this work outside Zawa may carry copyright risks.',
        pptDisableEditDesc: 'Download as "Non-editable PPT" format; PPT will be converted to images.',
        noCompression: ' (No compression)',
        persionUse: 'Personal/Non-Profit',
        commercialUse: 'Commercial',
        waterMarkDownload: '(With Watermark)',
        noWaterMarkDownload: '(Without Watermark)',
        pptWithEditText: 'The text in PPT is editable',
        pptDisableEditText: 'The text in PPT cannot be edited',
        savingTip: 'Saving... Please try again later.',
        saving: 'Saving…',
        downloadFail: 'Download failed, please try again later!',
        genImage: 'Downloading images... ${0} (${1}/${2})',
        cancel: 'Cancel',
        selectAll: 'Select All',
        splitDownloadAll: 'Download split pages (select all)',
        pagesDownloadAll: 'Download in pages (select all)',
        pageNum: 'Page ${0}',
        merageDownload: 'Combine and download',
        downloadEffectTip: 'Best if pages have equal size',
        selectOneTip: 'Select at least one page',
        longImageDownload: 'Download long image',
        allPagesDownload: 'All pages',
        selectedPage: ' (${0} page(s))',
        selectTip: 'Please select a page',
        selectedCountTip: '${0} page(s) selected',
        commercialInfo:
            'Commercial Use by Enterprises: Refers to corporations, individual businesses, administrative organizations, social groups, and other legal or non-legal entities using designs for profit-making activities.',
        personInfo:
            'Personal Commercial Use: Refers to situations where an individual uses designs for profit-making activities primarily carried out by themselves, with the individual ultimately benefiting from the proceeds.',
        welfareInfo:
            'Non-profit use: The use of licensed content for publicity and promotion of non-profit or charitable activities.',
        openVipAndDownload: 'Free download for members',
        downloadWorks: 'Download',
        workType: 'Format',
        adviceDownloadType: ' (Recommended)',
        downloadType: 'Download method',
        selectPageTip: 'Select page',
        workUseFor: 'Purpose',
        agreeAndDownload:
            'By downloading, you acknowledge that you have read and agreed to our <>Terms of Service</> and <>Privacy Policy</>.',
        downloadSuccess: 'Downloaded successfully',
        workWithCopyright: 'The current work has no copyright risk and can be used for commercial purposes.',
        workWithPersonal:
            'The current work is only for non-profit use. Commercial use involves the risk of infringement.',
        toCommercial: 'Commercial use',
        workAutoSaved: 'The creation has been saved to the records',
        aiWarning:
            '*This work contains AI content. If you want to use it for commercial purposes, please delete the AI content.',
        view: 'View',
        clickAndDownload: 'Download',
        designFileName: 'Unnamed design',
        size: 'Size',
        createCopy: 'Make a copy',
        file: 'File',
        backHome: 'Home',
        undo: 'Undo',
        redo: 'Redo',
        savedSuccess: 'Saved successfully',
        uploadedRecord: 'The drawing record has been saved to the project.',
        save: 'Save',
        autoSaving: 'Automatically saving...',
        newFile: 'Unnamed design work',
        saveRecord: 'Save creation',
        disableShareTip:
            'After sharing, the work will be unavailable for viewing due to the detection of prohibited content.',
        genShareLink: 'Generating link...',
        shareUrWork: 'Share your work',
        viewTip: 'Anyone who obtains the link can view your work.',
        copied: 'Copied',
        copyLink: 'Copy Link',
        showPPT: 'Presentation',
        selectMode: 'Select a mode',
        confirm: 'Confirm',
        title: '_Edit Page_Zawa',
        rename: 'Rename',
        openVipAndEnjoyMeidou: 'After subscribing to Zawa Pro, you will receive a fixed amount of credits every month.',
        projectName: 'Edit poster',
        shortcutKey: 'Shortcuts',
        share: 'Share',
        confirmTitle: 'Update tips',
        confirmContent: 'Unable to download multiple canvas. Please update to the latest version and try again.',
        confirmOk: 'Update now',
        confirmCancel: 'Try the web version for the best experience.',
        confirmDemoTitle: 'The current version is for demonstration use only',
        confirmDemoContent:
            'Click <>Meitu official website<> to download the latest version to experience the full functionality',
        confirmKnown: 'Got it',
        fontPaidToFree: 'Successfully replaced the paid font ${0} with the free font ${1}.',
        toMySpace: 'Creation saved to My Space',
        posterEditor: 'Poster Editor',
        imageEditor: 'Photo Editor',
        openImage: 'Open local image...',
        createCanvas: 'Create blank canvas',
        kindTips: 'Notice',
        downloadConfirm: 'Download the current image?',
        noThanks: 'No, thanks',
        tryOtherImage: 'Image loading failed. Try a different one!',
        loginToDownload: 'Log in to download',
        agreeAndDownloadIntl:
            'By downloading, you acknowledge that you have read and agreed to our <>Terms of Service</>.',
        noWaterMarkDownloadIntl: 'Without watermark',
        image: 'images',
        ppt: 'PPT',
        pdf: 'PDF',
        aipptDownloadWidthWatermark: 'With DesignKit watermark',
        feedbackTip: "Do you like our product?  We'd love your feedback.",
        writeFeedback: 'Write Feedback',
        feedback: 'Feedback',
        savingFile: 'Saving the exported file',
        downloadWithWatermark: 'Watermarked',
        publicUse: 'Non-Profit',
        personalCommercialUse: 'Personal Commercial Use',
        enterpriseCommercialUse: 'Commercial Use by Enterprises',
        availableEdit: '(Editable)',
        unavailableEdit: '(Non-Editable)',
        editable_ppt: 'PPT (Editable)',
        uneditable_ppt: 'PPT (Non-Editable)',
        pptDownloadWithoutWatermark: 'Without watermark',
        commercialInfo_v1: 'Commercial use: Use of licensed content for commercial purposes.',
        personInfo_v1:
            'Personal use: Use of licensed content for the purposes of personal study, research, or enjoyment.',
        pptDynamicBgDownloadTip: 'Dynamic templates cannot be demonstrated after downloading to a local computer.',
        createPPT: 'New PPT',
    },
    editor: {
        aiMaterial: {
            photo: 'AI Photo',
            bg: 'AI Background',
            text: 'Applying picture...',
            aiPhotoMaterial: {
                photoType: ' Photo Category<> (required)<>',
                tip: 'Choosing the appropriate category can enhance the quality of the image generated',
                errorText: 'Text or image cannot be empty',
                genFail: 'Failed to generate',
                title: 'Please enter description or upload a reference picture',
                placeholder:
                    'Try entering the content you want to generate\\nFor example: a carrot, red, realistic photo style',
            },
            backgroundAiMaterial: {
                genFail: 'Failed to generate',
                title: 'You can also customize content or upload reference images:',
                placeholder: 'For example: 3D exhibition stand, red',
                backgroundStyleType: 'Please select a background style<> (required)<>',
            },
            commonComponents: {
                generate: 'Paint Now',
                tip: 'By using this app, you agree to',
                protocol: 'AI Creator Terms of Service',
                cancel: 'Cancel',
                confirmText: 'Processing image... Confirm to exit?',
                confirm: 'Confirm',
            },
            inputContent: {
                fileType: 'Only supports PNG, JPEG, and JPG files',
                fileSize: 'Only supports images up to 20MB',
                uploadFail: 'File upload failed',
                emptyText: 'Text cannot be empty',
                require: '(required)',
                thinkText: 'Try AI results',
                loading: 'Loading…',
            },
            inputReferences: {
                refer: 'References:',
                effectStyle: 'Style effect',
                change: 'Switch',
                effectImgGenerate: '*You can apply a reference image for creation',
                random: 'Random',
                try: 'Try',
            },
            loadingSection: {
                imageGenerate: 'Generating image...',
                exampleText: 'A pyramid-like ice sculpture',
                tip: 'Tip: The more detailed the description, the more specific the effect will be. Phrases or sentences can be used.',
            },
            materialList: {
                apply: 'Apply',
            },
        },
        aiPoster: {
            constants: {
                trimText: 'Spaces-only is not allowed',
                supportLength: 'Up to ${1} characters for ${0}',
                commodity: 'Main image of e-commerce',
                logo: 'Logo Name',
                logoPlaceholder: 'Please enter the logo name',
                logoImg: 'Logo images',
                logoImgPlaceholder: 'Please upload a logo image',
                product: 'Product name',
                productPlaceholder: 'Please enter product name',
                price: 'Price',
                pricePlaceholder: 'Please enter price',
                priceMessage: 'Please enter Arabic numerals',
                marketingBenefits: 'Marketing strategy',
                marketingBenefitsPlaceholder: 'Please enter marketing strategy',
                sellingPoints: 'Product selling points',
                sellingPoints1Placeholder: 'Please enter the selling points of the product',
                mainImg: 'Images',
                mainImgPlaceholder: 'Upload images',
                sign: 'Daily greetings',
                mainTitle: 'Main title',
                mainTitlePlaceholder: 'Please enter main title',
                theme: 'Theme',
                themePlaceholder: 'Please enter a theme',
                subTitle: 'Subtitle',
                subTitlePlaceholder: 'Please enter a subtitle',
                desc: 'Description',
                descPlaceholder: 'Please enter a description',
                invitation: 'Event invitation',
                activityTheme: 'Event theme',
                activityThemePlaceholder: 'Please enter an event theme',
                activityTime: 'Event time',
                activityTimePlaceholder: 'Please enter activity time',
                activityAddress: 'Event Location',
                activityAddressPlaceholder: 'Please enter event location',
                invitationContent: 'Invitation letter content',
                invitationContentPlaceholder: 'Please enter the content of the invitation letter',
                qrCode: 'QR code',
                qrCodePlaceholder: 'Please upload the QR code',
                birthday: 'Birthday wishes',
                bestWishes: 'Blessing',
                bestWishesPlaceholder: 'Please enter your blessing',
                holiday: 'Festival greetings',
                announcement: 'Announcements',
                notifyContent: 'Announcement content',
                notifyContentPlaceholder: 'Please enter announcement content',
                notifyParty: 'Notifying party',
                notifyPartyPlaceholder: 'Please enter the notifying party',
                notifyTime: 'Notification time',
                notifyTimePlaceholder: 'Please enter notification time',
                recruitment: 'Recruitment',
                job: 'Position',
                jobPlaceholder: 'Please enter the recruitment position',
                salaryBenefits: 'Salary',
                salaryBenefitsPlaceholder: 'Please enter salary package',
                jobRequirements: 'Job requirements',
                jobRequirementsPlaceholder: 'Please enter job requirements',
                more: 'Coming Soon',
            },
            successUploadMessage: 'Uploaded',
            failedUploadMessage: 'Failed to upload. Please try again.',
            supportSizeImage: 'Only supports images up to ${0}MB',
            require: '(required)',
            requireMessage: '${0} must not be empty',
            logoUploadMessage: 'The logo image is being uploaded... Please wait.',
            qrCodeUploadMessage: 'The QR code is being uploaded... Please wait.',
            imageUploadMessage: 'Pictures are being uploaded... Please wait.',
            warnRequireMessage: 'Please fill in the required fields',
            confirmTitle: 'Update tips',
            confirmContent: 'Unable to download multiple canvas. Please update to the latest version and try again.',
            confirmOk: 'Update now',
            confirmCancel: 'Try the web version for the best experience.',
            downLoad: 'Downloading...',
            save: 'Saving…',
            fileName: 'Zawa AI Poster ${0}',
            fileName2: 'Zawa AI Poster ${0} .${1}',
            savingErrorMessage: 'Failed to save. Please try again.',
            noDataMessage: 'No data yet, please try again',
            supportSelectNum: 'You can only select ${0}',
            supportBatchSelect: 'You can only select ${0} posters',
            selectedNum: '${0} selected',
            selectAll: 'Select all',
            downLoadBtn: 'Download',
            editorBtn: 'Edit',
            selectPosterType: 'Select poster type',
            back: 'Back',
            try: 'Try',
            generate: 'Generate',
            jump: 'Redirecting...',
            openEditor: 'Open the editor',
            cancelOriginalPicture: 'Cancel original image',
            originalPicture: 'Original',
            editor: 'Edit',
            renderPosterList: {
                generateMore: 'Generate more',
                support: 'Technical support from Zawa',
                noMore: 'No more content',
            },
            renderNoData: {
                noGenerate: 'You have not generated a poster yet',
                generate: 'Please enter on the left to generate',
            },
            renderLoading: {
                generating: 'Generating poster...',
                noLeave: 'Please do not leave this page',
            },
        },
        models: {
            saved: '${0} Saved',
            autoSaving: 'Saving...',
        },
        share: {
            noPreview: 'Sensitive words or images found. Unable to access this content.',
            contactServer:
                'Please advise the owner to review the content of their work. If they need to know the specific details of the review process, they can contact customer service.',
            permission: 'Sorry, you do not have permission to view this file.',
            noFound: 'No relevant information found',
            toMySpace: 'Creation saved to My Space',
            toShare: 'Works can be found in "Share with me"',
            title: 'Share',
            downloadBtn: 'Download',
            editorBtn: 'Edit',
            shareBtn: 'Share',
        },
        header: {
            poster: 'Posters',
        },
        ppt: {
            loginAndRegister: 'Log in/Sign up',
            slogan: 'Enter a prompt and a PPT will be ready in 10 seconds',
            defaultPlaceholder: 'Please fill in the PPT topic you want',
            errorMessage: 'The system is busy. Please try again later.',
            innerTest: 'Beta',
            meidouText: '40 credits per day means 4 free generations per day.',
            generate: 'Generate',
            pptVideoTitle:
                'Efficiently solve your challenges in creating PPT files, from conceptualization and copywriting to design.',
            genPPt: 'Generating PPT...',
            genFirstPage: 'Generate page ${0}',
            new: 'New',
            newSlogan: 'Simply enter a prompt, and our AI delivers a high-quality PPT',
            page: 'pages',
            custom: 'Custom',
            create: 'Generate a free outline',
            try: 'Try these',
            noSave: 'Outline not saved',
            noSaveTip: 'Are you sure you want to go back and lose the current outline?',
            cancel: 'Cancel',
            confirm: 'Confirm',
            delete: 'Delete',
            deleteTip: 'You are about to delete all contents of this chapter. Are you sure you want to proceed?',
            regenerate: 'Regenerate',
            add: 'Create a new section below',
            addItem: 'Add section',
            outline: 'Outline',
            outlineTip: 'Edit the outline or proceed as it stands.',
            style: 'Template style',
            size: 'PPT text',
            createPPT: 'Generate PPT',
            pageNumber: 'Number of PPT pages',
            emptyMessage: 'The subject cannot be left blank',
            title: 'Title',
            sub_title: 'Subtitle',
            chapter: 'Chapter',
            addChapter: 'Add chapter',
            titleEmpty: 'The title cannot be left blank',
            subTitleEmpty: 'The subtitle cannot be left blank',
            chapterEmpty: 'The chapter cannot be left blank',
            contentEmpty: 'The section cannot be left blank',
            titlePlaceholder: 'Enter title',
            subTitlePlaceholder: 'Enter subtitle',
            chapterPlaceholder: 'Enter chapter',
            contentPlaceholder: 'Enter content',
            progress: 'Generating PPT...',
            progressTip: 'Turning your prompts into a PPT...',
            pptPage: '${0} page(s) PPT',
            record: 'AI PPT generation records',
            loadingText: 'Generating PPT... Please wait.',
            oneSentence: 'Simply enter a prompt',
            oneSentencePlaceholder: 'Our AI delivers a high-quality PPT',
            inAWord: 'Enter prompt',
            pasteText: 'Paste content',
            placeholder: 'Paste your notes, guidelines, or any text, and our AI will generate a PPT based on them.',
            exceedMaxLen: 'Please delete the excess part',
            clickAwait: 'Too many attempts. Try again later.',
            isVipButtonText: 'Unlimited generation for members',
            loadMore: 'More',
            contentRich: 'PPT text',
        },
        app: {
            fileName: 'Copy',
            confirmTitle: 'Notice',
            confirmContent:
                'The current feature has been upgraded! For an enhanced user experience, please visit our official website to download the latest version: https://pc.meitu.com',
            successMessage: 'The network has been reconnected',
            failedMessage: 'No network connection. Please check your network settings.',
            disableAppText: 'Import an image first',
        },
        unnamed: 'Untitled image',
        noImageInClipboard: 'No image detected on the clipboard. Try importing or dragging images.',
        incompatibleRecord: 'The current record cannot be loaded for some reason and can only be used as an image.',
        recordNoFound: 'Record not found. Select again.',
        openImage: 'Import',
        dragImageOr: 'Paste or drag images here or',
        createCanvas: 'New',
        records: 'Editing Records',
        trySample: 'Samples',
        support: 'Technical support from Zawa',
        aiShoeDesign: 'AI Product Design_Zawa',
        commercialWeb: 'AI Commercial Photography_Zawa',
        copyRight: 'Zawa',
    },
    stage: {
        usedCutoutCount: '${0} credit deducted',
        cutoutWarning: 'Insufficient number of credits',
        applyFail: 'Application failed, please try again later.',
        defaultText: 'Tap twice to edit text',
        viewImageInfo: 'Tap twice to replace image',
        addToSpaceTip: 'Right-click to add canvas elements to my space!',
        copyTip: 'Try copying the text style',
        AIExpendImage: 'AI is expanding the image',
        modifyImageTip: 'Click and drag to change the position of the picture',
        contrast: 'Compare',
        repaintTip: 'Partially redrawing...',
        paintTip: 'Left-click and brush to select',
        closePPT: 'End presentation',
        pptInfo: 'Click here to add a note',
        laserPen: 'Laser pointer',
        enable: 'Enable',
        disable: 'Disable',
        webFullScreen: 'Web page full screen',
        fullScreen: 'Full',
        exit: 'Exit',
        filter: 'Filters',
        shapeMask: 'Mask',
        textEffect: 'Text Effects',
        paidFunction: 'Paid features',
        aiEraser: 'AI Removal',
        restoration: 'Quality Restoration',
        aiEliminate: 'Object Remover',
        paidBrush: 'Paid brushes',
        downloadResultBtnText: 'Download',
        aiQuality: 'Image Enhancer',
        aiMatting: 'Remove Background',
        losslessResizing: 'Lossless Scaling',
        shortcutOpera: {
            addText: 'Add Text',
            text: 'Text',
            image: 'Image',
            brush: 'Brush',
            localUpload: 'Local',
            myPicture: 'My pictures',
            line: 'Line',
            arrow: 'Arrow',
            dash: 'Dotted line',
            square: 'Square',
            circle: 'Round',
            triangle: 'Triangle',
            markup: 'Marker',
            curve: 'Curve pen',
        },
        toolbar: {
            pressToView: 'Press and hold to view original photo',
            contrast: 'Contrast',
        },
        keyboard: {
            title: 'Shortcuts',
            function: 'Features',
            windows: 'Windows',
            mac: 'Mac',
        },
        buyVip: {
            text: 'Subscribe to remove watermark',
        },
    },
    collapse: {
        messageError: {
            requestFailed: 'Failed to request element',
            networkFailed: 'Network error. Unable to connect to the server.',
            noNetwork: 'Network connection lost. Please reconnect and try again.',
            heicError:
                'The HEIC image failed to load. We recommend converting it to another image format before uploading.',
            filetypeLimit: 'Only supports JPG, PNG, HEIC, SVG, GIF, and WEBP image formats',
            parsingFailed: 'Failed to load. We recommend converting it to another image format before uploading.',
            addFailed: 'Failed to add, please try again.',
        },
        tips: {
            deleteTitle: 'Delete image',
            deleteDesc: 'Once deleted, it cannot be retrieved. Please proceed with caution.',
            okText: 'Delete',
            cancelText: 'Cancel',
            deleteSuccess: 'Deleted successfully',
            addSuccess: 'Added successfully',
            addLoading: 'Adding...',
            selected: '<></> selected',
            recordDeleteDesc: 'Once the record is deleted, it cannot be retrieved. Please proceed with caution.',
            uploadDesc: 'Click to upload files or drag and drop',
            uploadLimit: 'Only supports images up to 20MB',
            uploadMaxLimit: 'Upload up to 10 images',
            noContent: 'No content',
            corner: 'Corner marker image',
            uploadSuccess: 'Uploaded',
            noMore: 'No more content',
            uploading: 'Uploading',
            sizeLimit: 'Only supports images up to ${0} x ${1}',
        },
        backgroundCollapse: {
            title: 'Color',
            detailTitle: 'Background Column Details',
            recentUsed: 'Frequently used',
            all: 'All',
            messageError: {
                applyFailed: 'Background application failed',
            },
            kindTips: 'Notice',
            applyTips: 'The photo has been edited. Apply this effect?',
            apply: 'Apply',
            cancel: 'Cancel',
            messageInfo:
                'This feature only applies to the original photo, Inaccessible content has been hidden automatically',
        },
        brushCollapse: {
            linePen: 'Linear pen',
            curvePen: 'Curve pen',
            shape: 'Shape',
            choose: 'Select drawing tool',
            tips: {
                moveToCanvas: 'Move to canvas and edit',
                firstClick: 'Tap to start marking',
                secondClick: 'Tap to end marking',
                thirdClick: 'Drag to extend the marking',
            },
            all: 'All',
            custom: 'Custom',
            markupPen: 'Marker',
            defineCurvePen: 'Customize curve pen',
            defineLinePen: 'Customize linear pen',
            penStyle: 'Brush style',
            stroke: 'Stroke',
            free: 'Limited time free',
        },
        materialCollapse: {
            newestTitle: 'New',
            detailTitle: 'Element Column Details',
            commonUsed: 'Frequently used',
            recentUsed: 'Recently used',
            recentSearch: 'Search history',
            clearRecord: 'Clear',
            hotSearch: 'Top searches',
            all: 'All',
            more: 'More',
            colors: 'Color',
            reload: 'Reload',
            feedback: 'Feedback',
            searchPlaceholder: 'Search elements',
            tips: {
                noContent: 'No content',
                noContentDesc: 'Try using a different search term ${0} or provide us with your feedback.',
                noNetwork: 'There is a problem with the network.${0} Try reloading.',
            },
            similarTitle: 'Similar Elements',
            viewMore: 'View more',
            similarRecommend: 'You may also like',
            loading: 'Loading...',
            similarTag: 'Similar Tags',
        },
        mineCollapse: {
            mySpace: 'Records',
            myRecord: 'Design records',
            reUpload: 'Upload',
            addMaterial: 'Add element',
            noRecord: 'No design records found. Start now!',
            pptPage: '${0} page(s) PPT',
            multiplePage: '${0} pages',
            all: 'All',
            delete: 'Delete',
            exit: 'Exit',
            image: 'Images',
            text: 'Text',
            group: 'Combine',
            folder: 'Folders',
            records: 'Designs',
            elements: 'Assets',
            myShare: 'Shared content',
            add: 'Add',
            noneFolder: 'No folders found',
            collapse: 'Collapse',
            expand: 'Expand',
            viewAll: 'View all',
            type: 'Type',
            noFilesYet: 'No files have been added',
            upload: 'Upload',
            poster: 'Poster Editor',
            imageEditor: 'Photo Editor',
            upGradeTipsTitle: 'New updates available!',
            upGradeTipsContent:
                'Both poster templates and photo editing records are included. Smooth switch from editing photos to designing posters.',
            upGradeTipsOk: 'Got it',
            steps: {
                content: 'Filter and Color are merged here',
                okText: 'Got it',
            },
            productShoot: 'AI Commercial Photography',
            aiLogo: 'AI Logo',
            aiShoeDesign: 'AI Product Design',
            aigcRecords: 'History',
        },
        templateCollapse: {
            recommend: 'For you',
            recentView: 'Recently viewed',
            homePage: 'Home',
            backToList: 'Back to list',
            applyAllPage: 'Apply to all pages',
            all: 'All',
            filter: 'Filter',
            feedback: 'Feedback',
            search: {
                placeholder: 'Search templates',
                hotSearch: 'Top searches',
                recentSearch: 'Search history',
                searchKeyword: 'Search "${0}"',
                clear: 'Clear',
            },
            tips: {
                noContent: 'No content',
                noContentDesc: 'Try using a different search term ${0} or provide us with your feedback.',
                applyWouldReplace: 'After using the template, the current content will be replaced.',
                replaceCurrentTemplate: 'Replace all pages',
                replaceCurrentPage: 'Replace current page',
                replaceAllPage: 'Replace all pages',
                replaceWouldApplyNewPage: 'How would you like to open this template?',
                replaceWouldApplyAllPage: 'After replacing the template, the content will be applied to all pages.',
                addToNewPage: 'In a new page',
                replace: 'Replace',
                cancel: 'Cancel',
                openNewTab: 'In a new tab',
            },
            aippt: {
                replaceTemplateTitle: 'Switch',
                applyTemplateBtn: 'Switch',
                selectTemplateTip: 'Please select a template first',
            },
        },
        teamCollapse: {
            template: 'Templates',
            material: 'Elements',
            group: 'Tag group',
            ungrouped: 'Ungrouped',
            backToList: 'Back to list',
            applyAllPage: 'Apply to all pages',
            addMaterial: 'Add element',
            reUpload: 'Upload',
            importTemplate: 'Import template',
            all: 'All',
            upload: 'Upload',
            exit: 'Exit',
            delete: 'Delete',
            tips: {
                uploading: 'Uploading',
                noText: 'No text layer',
                noTag: 'There are no tags in the group yet',
                noTemplate: 'There is no template yet. Upload your template.',
                parsing: 'Parsing...',
                parseFailed: 'Failed to parse',
                parseSuccess: 'Parsed successfully',
                reUpload: 'Upload',
                continueUpload: 'Continue',
                uploadSuccess: 'Uploaded',
                chooseFile: 'Select a document',
                dropFileOr: 'Drag files here to upload, or',
                psdImportSpecification: 'PSD file import specifications',
                applyWouldReplace: 'After using the template, the current content will be replaced.',
                replaceCurrentTemplate: 'Replace current template',
                replaceCurrentPage: 'Replace current page',
                replaceAllPage: 'Replace all pages',
                replaceWouldApplyNewPage: 'After replacing the template, the content will be applied to the new page.',
                replaceWouldApplyAllPage: 'After replacing the template, the content will be applied to all pages.',
                addToNewPage: 'Add as new page',
                replace: 'Replace',
                cancel: 'Cancel',
            },
            messageError: {
                needUploadPsd: 'Please upload PSD file!',
                psdSizeLimit: 'Please verify if the PSD file exceeds 600MB.',
                uploadFailed: 'Failed to upload.',
                uploadFailedReTry: 'Failed to upload. Please try again.',
            },
        },
        navigationCollapse: {
            createPage: 'Create new page',
            addPage: 'Add page',
            copyPage: 'Copy page',
            deletePage: 'Delete page',
            submit: 'Submit',
            ppt: {
                currentSubject: 'Current PPT theme',
                prompt: 'Prompt (command)',
                placeHolder:
                    'Review the generated content and provide a related description for AI to enhance it, e.g., "Include additional details about ${0} in the PPT."',
                singlePptGenerate: 'Generate single-page PPT',
                tips: {
                    generateSuccess: 'Generated successfully',
                    singlePptGenerating: 'Generating single-page PPT...',
                    pptReGenerating: 'Regenerate page ${0}',
                    reGenerate: 'Try again',
                },
            },
            replaceComponentTitle: 'Choose a style',
            changeAnotherComponent: 'Switch',
            componentReplaceing: 'Applying style...',
            noComponentTip: 'No qualified style matched',
        },
        textCollapse: {
            defaultText: 'New Text',
            commonUsed: 'Frequently used',
            recentUsed: 'Recently used',
            clickToAddText: 'Click to add text',
            title: 'Title',
            subTitle: 'Subtitle',
            contentText: 'Body',
            more: 'More',
            all: 'All',
            messageError: {
                needNewest: 'Please use the latest text elements',
                fetchFailed: 'Failed to obtain element',
            },
            search: {
                placeholder: 'Enter text',
            },
            defaultPPTTextMap: {
                title: '双击编辑标题',
                subTitle: '双击编辑副标题',
                authorAndDate: '作者和日期',
            },
        },
        moreCollapse: {
            componentTool: {
                title: 'Components',
                table: {
                    title: 'Sheet',
                    desc: 'Provides rich styles and supports importing Excel files.',
                    importExcel: 'Import Excel files',
                    importExcelLimit: 'Import Excel files with ${0} rows and ${1} columns',
                    needSelected: 'Select style',
                    messageError: {
                        filetypeLimit: 'Only supports .xlsx files',
                    },
                },
                qrCode: {
                    title: 'QR code',
                    desc: 'Generate QR codes for websites or official accounts, all while offering a wide variety of stylish designs.',
                    website: 'Website',
                    official: 'Official account',
                    needSelected: 'Select style',
                    createQrCode: 'Create QR code',
                    uploadQrCode: 'Upload',
                    messageError: {
                        officialInputError: 'Please enter correct official account',
                        recognitionFailed: 'Recognition failed. Please upload a correct and clear QR code image.',
                    },
                    intlDesc: 'Generate QR codes from website addresses with customizable styles.',
                    intlTabTip: 'Enter website address',
                },
            },
            imageModal: {
                title: 'Before using ${0}, please select an image first!',
                desc: 'Select an image from a poster template',
                uploadImage: 'Upload',
                messageError: {
                    uploadFailed: 'Failed to upload photo',
                },
            },
            imageTool: {
                title: 'Picture tools',
                generate: 'Generate',
                generating: 'Generating...',
                result: 'Results:',
                reGenerate: 'Generate again',
                imGenerate: 'Generate',
                image: 'Images',
                apply: 'Apply',
                exit: 'Exit',
                messageError: {
                    failed: 'Failed to generate',
                    aiFailed: 'AI ${0} failed',
                    meidouReturned: 'The credits have been returned',
                },
                aiExpend: {
                    title: 'AI Image Extender',
                    desc: 'Enhance your images by expanding them from their original size, with support for a variety of size options.',
                    originalRadio: 'Original',
                    sizeTitle: 'Size',
                    radioTitle: 'Ratio',
                    expend: 'Expansion',
                    toast: "You've reached the canvas limit and can't expand the image further.",
                },
                aiModify: {
                    title: 'Modify',
                    desc: 'Enter a description, and AI will generate image content within the specified area based on the description.',
                    internalTest: 'Beta',
                    promptDefault: 'A groundhog',
                    paintTitle: 'Brush to select:',
                    paintDescTitle: 'Enter your description:',
                    tips: {
                        inputLimit: 'You can enter up to 1,000 characters',
                        inputPlaceholder: "Please describe the content you're looking for",
                        guide: 'Please select the area and fill in your description',
                    },
                    modify: 'Try again',
                    reset: 'Reset',
                },
                imageTranslation: {
                    title: 'Image Translation',
                    desc: 'Easily translate and edit image text in multiple languages to streamline cross-border marketing.',
                    selectOriginalLanguage: 'Select source language',
                    selectTranslation: 'Select target language',
                    translate: 'Translate',
                    translateAgain: 'Retry',
                    original: 'Source',
                    translation: 'Target',
                    translationResult: 'Result',
                    noResult: 'No content found in the source language. Please make another selection.',
                    fail: 'Image translation failed. Please try again.',
                    ok: 'Got it',
                    apply: 'Confirm',
                    cancel: 'Cancel',
                    confirmText:
                        "If you exit now, the translation will be interrupted, and you won't be able to continue from where you left off. Do you want to exit anyway?",
                    sameSelect:
                        'You’ve selected the same language for both the source and target. Please choose different languages.',
                },
            },
            textTool: {
                title: 'Text tool',
                generate: 'Generate',
                generating: 'Generating',
                result: 'Results:',
                reGenerate: 'Generate again',
                imGenerate: 'Paint Now',
                aiText: {
                    title: 'AI Calligraphy',
                    desc: 'Creative text effects, perfect for poster headlines.',
                    generating: 'Generating AI calligraphy...',
                    selectedTitle: 'Featured effects',
                    aiTextDesc: 'Generate 1 to ${0} characters at a time for best results',
                    content: 'Text',
                    font: 'Font',
                    style: 'Style',
                    textPreview: 'Text preview:',
                    tips: {
                        inputPlaceholder: 'Please enter content',
                        disclaimer: 'Disclaimer',
                        disclaimerContent:
                            "Before using this service, you must understand that the content produced by AI depends on the deep learning of big data by artificial intelligence. There may be flaws, irrationalities, or displeasing elements in some of the information. Hence, Zawa does not guarantee the accuracy, completeness, and functionality of the content generated by the algorithm, nor does it assume any legal responsibility, including infringement of third-party rights. Moreover, as the AI design service generates related content based on the text information you input, you need to make rational choices about the input information and the generated content. You must ensure that you use this service and its AI-generated works in accordance with the law, without infringing on any third party's copyright, trademark, or other legal rights. You may not use the generated works for any illegal purposes. If any third party's rights are damaged due to your improper use, you will bear the corresponding legal responsibility according to the law.",
                    },
                    messageError: {
                        needContent: 'Please enter content',
                        needSelected: 'Please select an effect',
                        failed: 'Generation failed, please try again.',
                        inputLimit: 'Enter up to ${0} characters',
                    },
                },
            },
            migrateHint: 'Click Add to create tables and QR codes',
            batchTool: {
                title: 'Batch Processing',
                aiSizeExtend: {
                    title: 'Resize',
                    desc: "Adjust an image's width and height, keeping or changing its aspect ratio.",
                    currentCanvasSize: 'Current size',
                    unit: 'Unit',
                    selectDesc: 'Select a size',
                    free: 'Limited time free',
                    width: 'W',
                    height: 'H',
                    generateBtnText: 'Generate ${0} resize page(s)',
                },
                batchTemplate: {
                    title: 'Templated Multi-Design',
                    desc: 'Simply input text or images to generate a multitude of posters with the same template but different content.',
                    operateTip: 'Select an element - Click Match Tag - Choose a tag',
                    changeDataBtnText: 'Edit',
                    generateBtnText: 'Generate ${0} page(s)',
                    exitBtnText: 'Exit this page',
                    clearTableBtnText: 'Clear',
                    nextBtnText: 'Next',
                    cancelBtnText: 'Cancel',
                    conformBtnText: 'Confirm',
                    noInputLabelTip: 'Select a tag and enter a name',
                    noMatchLabelTipText:
                        'Some tags have not been matched yet. Continuing the generation process will result in the loss of this information. Do you wish to proceed?',
                    clearAllDataTipText:
                        'Upon exiting, the information filled in will be cleared. Are you sure you want to exit?',
                    max80PageTipText: 'The number of pages exceeds the limit (80). Adjust the number and try again.',
                    onlyUploadPngJpgTipText: 'Only images in JPG or PNG format can be uploaded',
                    maxFileSizeTipText: 'Only supports images up to 20MB',
                    maxImageSizeTipText: 'The dimensions of the image must not exceed 8000 pixels',
                    inputLabelTypePlaceholder: 'Enter tag name',
                    labelTypeImageName: 'Image',
                    labelTypeTextName: 'Text',
                    labelTypeNoSelectName: 'Type',
                    tableInputLine1:
                        '1. Please select the type of tag from the dropdown menu: text or image, and then enter the tag name.',
                    tableInputLine2: '2. After selecting a tag, fill in the corresponding content or upload an image.',
                    clearTableTipText: 'Are you sure you want to clear the current table content?',
                    changeLabelTypeClearDataTipText:
                        "After switching types, the information you've filled in will be cleared. Are you sure you want to proceed?",
                    noMatchLayerText: 'Not matched yet',
                    isGeneratingText: 'Generating...',
                    tipTitle1: 'Manul input:',
                    tipTitle2: 'Upload file:',
                    tip1: '1. Please select the type of tag from the dropdown menu: text or image, and then enter the tag name.',
                    tip2: "2. Once you've confirmed the tag, add text content or upload an image.",
                    tip3: '1. Both .xlsx and .xls file formats are supported.',
                    tip4: '2. The first row of content will be identified as tag information, while any content below it will be recognized as page information.',
                    tip5: '3. Images are not supported.',
                    uploadBtn: 'Upload',
                    uploadTip: 'The information already filled in will be overwritten. Do you want to continue?',
                    uploadFailTip: 'Please ensure that you upload files in the correct format',
                    layerOperate: {
                        cover: 'Fill',
                        full: 'Fit',
                    },
                },
            },
            chartTool: {
                title: '图表',
                barName: '柱状图',
                lineName: '折线图',
                pieName: '饼图',
                horizontalBarName: '条形图',
            },
        },
        shortcutCollapse: {
            picture: {
                title: 'Images',
                localUpload: 'Local',
                myPicture: 'My Images',
                more: 'More',
                imageLib: 'Image Library',
                addBackground: 'Background',
            },
            text: {
                menuTitle: 'Text',
                title: 'Title',
                subTitle: 'Subtitle',
                text: 'Body',
                deformedLetters: 'Deformed text',
                specialEffectText: 'Special effects',
                more: 'More',
            },
            Brush: {
                title: 'Lines',
                more: 'More',
            },
        },
        adjustCollapse: {
            cropTitle: 'Crop/Rotate/Size',
            sizeAdjustment: 'Size',
            proportionalCrop: 'Crop',
            shapeMask: 'Mask',
            okText: 'Confirm',
            cancelText: 'Cancel',
            intelligentColor: 'Change Color',
            sourceColor: 'Source color',
            sourceColorDesc: 'Select a color from the image',
            colorTolerance: 'Color tolerance',
            targetColor: 'Target color',
            targetColorDesc: 'Target color',
            eraser: 'Erase',
            eraserDesc: 'Swipe to erase or select areas',
            clear: 'Clear',
            recommendedEffect: 'Suggested',
            resetEffect: 'Reset',
            manualColor: 'Manual',
            hue: 'Hue',
            saturation: 'Saturation',
            brightness: 'Luminosity',
            clearEffect: 'Clear Effect',
            noEffectOnEmptyCanvas: "The current feature doesn't work with the blank canvas",
            addCustomSize: 'Save as Custom Size',
            apply: 'Apply',
            custom: 'Custom',
            lockedScale: 'Ratio locked',
            unLockedScale: 'Ratio unlocked',
            leftRotate: 'Left rotate 90°',
            rightRotate: 'Right rotate 90°',
            horizontalFlip: 'Flip (H)',
            verticalFlip: 'Flip (V)',
            reset: 'Reset',
            freeCutting: 'Free',
            px: 'px',
            cm: 'cm',
            cropList: {
                square: '1:1',
                verticalCamera: '2:3',
                horizontalCamera: '3:2',
                standardVerticalScreen: '3:4',
                standardHorizontalScreen: '4:3',
                verticalVideo: '9:16',
                horizontalVideo: '16:9',
                verticalFullScreen: '9:18',
                horizontalFullScreen: '18:9',
                widescreenPhotoAlbum: '5:3',
            },
            losslessResizing: 'Lossless Scaling',
            losslessResizingDesc: 'Enhance image quality for optimal clarity',
        },
        filterCollapse: {
            confirmTitle: 'Notice',
            confirmContent: 'The photo has been edited. Apply this effect?',
        },
        watermarkCollapse: {
            addSuccessText: 'Added successfully',
            onLineError: 'Network connection lost. Please reconnect and try again.',
            all: 'All',
            confirmContent:
                'You can only edit one watermark. If you proceed, your current watermark will be replaced. Would you like to proceed?',
            confirmNoMind: "Don't show again",
            confirmTitle: 'Reminder',
            confirmOk: 'Confirm',
            confirmCancel: 'Cancel',
            materialDetail: 'Element Column Details',
            recommendMaterial: 'Recommended',
            recentlyMaterial: 'Recently used',
            uploadWatermark: 'Upload',
            limitImageSize: 'Only supports images up to 20MB',
        },
        brandLibCollapse: {
            brandTabTitle: 'Brand Standards',
            templateTabTitle: 'Template Library',
            textStyleTitle: 'Text style',
            logoTitle: 'Logo',
            more: 'All',
            emptyText: 'No content',
        },
        mogCollapse: {
            preset: 'Color Presets',
            reset: 'Reset',
            none: 'None',
        },
    },
    panel: {
        backgroundPanel: {
            canvas: 'Canvas',
            canvasSize: 'Canvas size',
            adjustSize: 'Size',
            horizontalFlip: 'Flip (H)',
            verticalFlip: 'Flip (V)',
            canvasBackground: 'Background',
            restoreBackground: 'Original',
            width: 'W',
            height: 'H',
            replace: 'Replace',
            crop: 'Crop',
            color: 'Color',
            image: 'Images',
            uploadImage: 'Upload',
            cropLimit: 'The current setting is a tiled background, which does not support the cropping feature.',
            splitBackground: 'Separate background',
            opacity: 'Opacity',
            clickOrDropToUpload: 'Click to upload image${0}or drag and drop files into the box to upload.',
            customSize: 'Custom',
            originalSize: 'Original',
            saveSize: 'Save size',
            presetSize: 'Presets',
            unit: 'Unit:',
            lockRatio: 'Lock aspect ratio',
            customRatio: 'Custom',
            smartLayout: 'Smart typesetting',
            tips: {
                splitSuccess: 'The background has been separated',
                deleteConfirm: 'Are you sure you want to delete this size?',
                okText: 'Confirm',
                cancelText: 'Cancel',
                deleteSuccess: 'Deleted successfully',
                saveSizeSuccess: 'Custom size saved successfully',
                adjustSizeWouldChangeLayout: 'After modification, the current template layout will change.',
                addToMySize: 'Add to my sizes',
                add: 'Add',
                inputSizeName: 'Enter a name',
            },
            messageError: {
                uploadNumLimit: 'You can only upload 1 image',
                canvasSizeLimit: 'Canvas size needs to be within limits',
                saveSizeFailed: 'Failed to save custom size',
                autoAdjustedToLimit: 'The dimensions have been reset to match the preset',
            },
            background: 'Background',
            imageSize: 'Size',
            backgroundSize: 'Size',
            customSizeTitle: 'My Sizes',
            addSize: 'Add',
            recommendSizeTitle: 'Recommended',
            currentCanvasSize: 'Current size',
            aiSizeExtend: 'Resize',
            free: 'Limited time free',
            smartLayoutTip: 'Maintain element layout within the canvas unchanged while resizing',
            recommendColor: 'Color suggestions',
            currentBgColor: 'Current color',
            selectFromBackground: 'Select from library',
            dynamicPanel: {
                title: 'Dynamic background',
                hiddenLabel: 'Display',
                open: 'On',
                close: 'Off',
            },
        },
        brushPanel: {
            brush: 'Brush',
            brushPen: 'Brush',
            shape: 'Shape',
            style: 'Style',
            stroke: 'Stroke',
            color: 'Color',
            endpoint: 'Endpoint',
            opacity: 'Opacity',
            radius: 'Rounded corners',
            thickness: 'Size',
        },
        groupPanel: {
            multiSelect: 'Choose multiple',
            group: 'Combine',
            makeGroup: 'Combine',
            breakGroup: 'Cancel combination',
            mergeLayer: 'Merge layers',
            tips: {
                breakGroupVipLimit: 'Paid element cannot be ungrouped',
                mergeConfirm:
                    'After merging, the selected layers will become one picture. Do you want to confirm the merging?',
                okText: 'Merge',
                cancelText: 'Cancel',
            },
        },
        imagePanel: {
            image: 'Images',
            aiImage: 'AI pictures',
            imageSetting: 'Settings',
            imageAdjust: 'Color',
            baseImageAdjust: 'Basic Correction',
            advancedImageAdjust: 'Advanced Correction',
            adjustLight: 'Light',
            adjustColor: 'Color',
            adjustParticulars: 'Details',
            adjustPosterize: 'Posterize',
            adjustHsl: 'HSL',
            effect: 'Effects',
            imageEliminatePen: 'Object Remover',
            cancel: 'Cancel',
            complete: 'Done',
            undo: 'Undo',
            redo: 'Redo',
            reset: 'Reset',
            delete: 'Delete',
            exit: 'Exit',
            imageFilter: 'Filters',
            imageMask: 'Mask',
            aiGenerateImageTitle: 'AI picture content description',
            aiGenerateImageDesc:
                'You can modify the visual description, style, and color effects of the current element ${0} according to your needs.',
            inputPlaceholder: 'Please enter',
            generatingImage:
                'We are diligently working to bring the vision in your mind to life. Please bear with us for a moment.',
            reGenerate: 'Try again',
            cutoutMemberLimit: 'Insufficient number of credits. Become a member to get more.',
            cutoutRechargeLimit: 'Insufficient number of credits. Top up for more.',
            monthMemberPresent: 'Receive 50 uses/month with a monthly membership',
            seasonMemberPresent: 'Subscribe to Zawa Pro for credits.',
            yearMemberPresent: 'Receive 1,200 uses/year with a yearly membership',
            activateMember: 'Subscribe',
            discountedPrice: 'Best price $0.12/credit',
            permanentlyValid: 'The purchase is permanently valid',
            rechargeNow: 'Top up',
            replaceImage: 'Replace image',
            imageCrop: 'Crop',
            imageCutout: 'Cutout',
            opacity: 'Opacity',
            pasterDesc: 'Take a screenshot and press ${0} to paste image here',
            import: 'Import',
            mySpace: 'Assets',
            teamMaterial: 'Team Elements',
            selectedPhoto: 'Featured images',
            importClipboard: 'Local',
            addImage: 'Add',
            unnamed: 'Unnamed',
            format: 'Format:',
            size: 'Size:',
            tips: {
                uploadSuccess: 'Uploaded',
                uploadLimit: 'Only supports images up to 20MB.',
                deleteTitle: 'Delete image',
                deleteDesc: 'Once deleted, it cannot be retrieved. Please proceed with caution.',
                okText: 'Delete',
                cancelText: 'Cancel',
                deleteSuccess: 'Deleted successfully',
                selected: '<></> selected',
                noMaterial: 'No content yet. Click to add elements to upload.',
                matting: 'Processing...',
                bathAdd: 'Batch add',
            },
            messageError: {
                generateFailed: 'Failed to generate image',
                networkError: 'Network error. Unable to connect to the server.',
                importFailed: 'Import failed',
                filetypeLimit: 'Only supports JPG, PNG, HEIC, and SVG image formats',
                uploadFailed: 'Failed to upload.',
            },
            share: {
                uploadImage: 'Upload',
                uploadTip: 'Upload, drop or paste images here.',
                imageTip: 'Supports uploading JPG, JPEG or PNG files up to 20MB, with a maximum of ${0} images.',
                bathAdd: 'Batch add',
                imageTipText: 'JPG, JPEG and PNG images within 20 MB are supported',
                uploadCountTip: 'You can add up to ${0} images',
            },
            removeBgTip: 'Tap to remove background',
            imageEliminatePenButton: 'Eraser',
            productRetouching: 'Product Editor',
            imageAIExpand: 'Image Extender',
            imageMore: 'More >',
            imageGenerate: 'AI Generation',
            imageModify: 'Modify',
            imageQuality: 'Image Enhancer',
            imageTranslation: 'Image Translation',
            imageUpscale: 'Image Upscaler',
        },
        qrCodePanel: {
            qrCode: 'QR code',
            style: 'Style',
            color: 'Color',
            opacity: 'Opacity',
            backgroundColor: 'Background color',
            qrCodeColor: 'QR code color',
            website: 'Website',
            official: 'Official account',
            websitePlaceholder: 'Enter URL here',
            officialPlaceholder: 'Enter official account here',
            uploadIdentify: 'Upload',
            updateQrCode: 'Update QR code',
            selectStyle: 'Please select a style',
            messageError: {
                websiteInputError: 'Please enter the correct URL',
                officialInputError: 'Please enter correct official account',
                recognitionFailed: 'Recognition failed. Please upload a correct and clear QR code image.',
            },
        },
        tablePanel: {
            table: 'Sheet',
            opacity: 'Opacity',
            textStyle: 'Text style',
        },
        textPanel: {
            text: 'Text',
            style: 'Style',
            normal: 'Regular',
            textEffect: 'Text Effects',
            textTransform: 'Warp Text',
            advanceSetting: 'More settings',
            textStyle: 'Text style',
            transform: 'Warp',
            messageError: {
                generateFailed: 'Failed to generate text',
            },
            textMark: 'Mark',
        },
        vectorPanel: {
            vectorShape: 'Graphics',
            style: 'Style',
            stroke: 'Stroke',
            color: 'Color',
            opacity: 'Opacity',
            radius: 'Rounded corners',
            thickness: 'Size',
            blur: 'Blur',
            vectorEffect: 'Graphics',
            effect: {
                shadow: 'Shadows',
                reflection: 'Reflection',
                stroke: 'Stroke',
                distance: 'Distance',
                size: 'Size',
            },
            modalTitle: 'Round',
        },
        watermarkPanel: {
            openTile: 'Tiling ON',
            closeTile: 'Tiling OFF',
            watermarkText: 'Text',
            placeholderText: 'Enter text',
            watermarkSize: 'Size',
            watermarkSpace: 'Spacing',
            watermarkCross: 'Overlap',
            watermarkRotate: 'Rotate',
            requireLogin: 'Log in before uploading',
            limitImageSize: 'Only supports images up to 20MB',
            replace: 'Replace',
            watermark: 'Watermarks',
            settingStyle: 'Styles',
            onlySupport: 'Tiling effect is available for watermarks only',
            opacity: 'Opacity',
            fontColor: 'Font color',
            tileDisplay: 'Tiling',
        },
        markupPanel: {
            brush: 'Brush',
            label: 'Text',
            type: 'Type',
            num: 'Value',
            custom: 'Text',
            unit: 'Unit',
            unitPlaceholder: 'Select unit',
            unitTip:
                'When multiple units are selected, the entered values will be converted and displayed using the smallest unit. For example: 100mm/10cm/3.94inch.',
            text: 'Text',
            textPlaceholder: 'Enter text',
            position: 'Position',
            up: 'Above the line',
            center: 'In the middle of the line',
            down: 'Below the line',
            rotate: 'Angle',
            fontFamily: 'Font',
            fontSize: 'Size',
            style: 'Style',
            background: 'Background color',
            stroke: 'Stroke',
            color: 'Color',
            thickness: 'Size',
            endpoint: 'Endpoint',
            line: 'Show extension line',
            opacity: 'Transparency',
            segment: 'Guide',
            lineStyle: 'Line style',
            angle: 'Angle',
            angleArea: 'Degree',
        },
        mediaPanel: {
            media: 'Media',
            opacity: 'Opacity',
            posterPlaceholder: 'Enter video cover url here',
            videoUrlPlaceholder: 'Enter video url here',
            updatePoster: 'Update cover',
            updateVideoUrl: 'Update video url',
            posterInputError: 'Please enter the correct video cover url',
            videoUrlInputError: 'Please enter the correct video url',
        },
        productRetouchingPanel: {
            common: 'General',
            hardware: 'Tools & Hardware',
            cosmetic: 'Cosmetics',
            leatherProducts: 'Leather Products',
            pending: 'Processing...',
            failed: 'Failed to process. Please try again.',
            limit: 'Daily trial limit reached. Go unlimited with our membership!',
            activateCancel: 'Not now',
            activateMember: 'Subscribe',
        },
    },
    layers: {
        text: 'Text',
        image: 'Images',
        vector: 'Graphics',
        background: 'Background',
        group: 'Combination',
        qrCode: 'QR code',
        table: 'Sheet',
        brush: 'Brush',
    },
    hooks: {
        useNetWork: {
            onLine: 'The network has been reconnected',
            unOnLine: 'Network error. Please try again or check your network status.',
        },
        uploadMaxLimit: 'Upload up to 10 images',
        common: 'General',
        designFileName: 'Unnamed design',
        reasonToDefaultTemplate: '${0}. Switch to request default template.',
        failedToDefaultTemplate: 'Template request failed. Switch to request default template.',
        fontsRemoved: 'The ${0} font is no longer available and the default font has been applied.',
        loadFailed: 'Failed to load template',
        editOnLeft: 'Edit calligraphy on the left',
        generationCompleted: 'Completed',
        generating: 'Creating page ${0}... (${1} /${2} )',
        functionalFailure: 'Functional failure',
        jumpToRecord: 'Redirect to records in 3 seconds',
        notLatestRecord: 'The current design is not the latest version, please refresh and try again.',
        refresh: 'Refresh',
        cancel: 'Cancel',
        tryAgainLater: 'Operation too frequent. Try again later.',
        uploadFailed: 'Failed to upload record. Try again.',
        failedToSave: 'Failed to save',
        failedToLoadRecord: 'Failed to load the records',
        textMaterialHide: 'Incompatible text has been automatically removed',
    },
    menu: {
        template: 'Templates',
        bg: 'Background',
        text: 'Text',
        material: 'Elements',
        draw: 'Lines',
        pic: 'Images',
        space: 'Space',
        pages: 'Pages',
        more: 'More Tools',
        team: 'Team',
        add: 'Add',
        mine: 'Records',
        filter: 'Filters',
        waterMark: 'Watermarks',
        adjust: 'Adjust',
        brandLib: 'Brand',
        element: 'Elements',
        mog: 'Color',
    },
    'ie-tip': {
        title: 'Your current browser may have compatibility issues. To ensure the optimal use of Zawa, we recommend switching to a different browser.',
        cancelText: 'Continue anyway',
        okText: 'Got it',
    },
    extensions: {
        refreshAndTryAgain: 'An error has occurred, please refresh and try again.',
        dragToAdjust: 'Drag to adjust the position, size, and angle of the product image',
        clickToReplace: 'Tap twice to replace product image',
        aiQuality: {
            title: 'Image Enhancer',
            desc: 'Instantly denoise and enhance your images.',
            aiQualityLevel: 'Select an image quality:',
            hd: 'HD',
            hdu: 'UHD',
            improving: 'Processing...',
            sd: 'SD',
        },
        aiMatting: {
            title: 'Background Remover',
            aiMattingType: 'Subject type:',
            none: 'None',
            human: 'Portrait/Pet',
            thing: 'Product',
            icon: 'Icon/Stamp',
            advanceEdit: 'Advanced:',
            mattingOptimize: 'Optimize Cutout',
            matting: 'Processing...',
            mattingFailed: 'No portrait/pet/product/icon/stamp was recognized',
            desc: 'Remove backgrounds instantly with just one tap.',
            loading: 'Loading...',
        },
        reset: 'Reset',
        okText: 'Confirm',
        cancelText: 'Cancel',
        aiUpscale: {
            title: 'Lossless Scaling',
            desc: 'Seamless Scaling, Perfect Clarity.',
            improving: 'Processing...',
            errorCode2: 'No image address found',
            errorCode3: 'Select or enter at least one size.',
            errorCode4: 'Enter the correct size',
            errorCode5: 'Daily trial limit reached. Go unlimited with our membership!',
            errorCode7: 'Generation failed',
            errorCode8: 'Request timed out. Please try again.',
            errorCode9: 'Operation failed. Contact customer service for assistance.',
            activateCancel: 'Not now',
            activateMember: 'Subscribe',
        },
        commercial: {
            outLimit: 'Daily limit reached. Come back tomorrow to continue.',
            know: 'Got it',
            freeErrorMessage: 'Daily trial limit reached. Go unlimited with our membership!',
            onText: 'Subscribe',
            tomorrow: 'Not now',
            noRulersError: 'Operation failed. Contact customer service for assistance.',
            nonVipForeverErrorMessage: 'Your trial limit has been reached. Go unlimited with our membership!',
        },
    },
    guidePopover: {
        addEntryTip: 'Tap to add elements',
    },
    globalMask: {
        loading: 'Loading...',
    },
    textFontSizeAndTextColor: {
        size: 'Size',
    },
};
